<template>
  <div class="prog">
    <el-progress type="circle" :width="500" :percentage="percentage" :color="colors"></el-progress>
  </div>

</template>
<script>
  import Vue from 'vue'
  import elementui from 'element-ui';
  import 'element-ui/lib/theme-chalk/index.css';
  Vue.use(elementui)

  export default {
    name: "",
    title: "登录中",
    data () {
      return {
        colors: [
          { color: '#f56c6c', percentage: 20 },
          { color: '#e6a23c', percentage: 40 },
          { color: '#5cb87a', percentage: 60 },
          { color: '#1989fa', percentage: 80 },
          { color: '#6f7ad3', percentage: 100 }
        ],
        percentage: 10,
        flag: false
      }
    },
    mounted () {
      var reurl = window.location.href;
      var _this = this;
      var code = this.$tool.getQueryString("code");
      if (code) {
        this.Ajax.Get("/api/Login/GetTokenByCode/" + this.$config.LoginAppId + "/" + code).then(res => {
          if (this.percentage < 50) {
            this.percentage = 50;
          }
          this.$tool.ss.Set(this.$config.LoginToken, JSON.stringify(res.data));
          this.Ajax.Get("/api/Role/GetRole").then(role => {
            if (this.percentage < 90) {
              this.percentage = 90;
            }
            res.data.role = role.data;
            this.$tool.ss.Set(this.$config.LoginToken, JSON.stringify(res.data));
            this.$tool.ss.Set("TopIndex", "");
            this.$tool.ss.Set("LeftIndex", "");
            this.Ajax.Get("/api/Menu/GetAllRouter").then(res => {
              this.$tool.ss.Set("Router", JSON.stringify(res.data));
              this.$router.push({ name: "Index" });
            });
          })
        })
        // this.$wxtool.GetCodeUser(code).then(res => {
        //   if (this.percentage < 50) {
        //     this.percentage = 50;
        //   }
        //   this.Ajax.Get("/api/Login/GetTokenByUserID/" + res).then(res => {
        //     this.$tool.ss.Set(this.$config.LoginToken, JSON.stringify(res.data));
        //     this.$tool.ss.Set("TopIndex", "");
        //     this.$tool.ss.Set("LeftIndex", "");
        //     this.Ajax.Get("/api/Menu/GetAllRouter").then(res => {
        //       this.$tool.ss.Set("Router", JSON.stringify(res.data));
        //       this.$router.push({ name: "Index" });
        //     });
        //   })
        // }).catch(() => {
        //   this.$tool.System.alert("登陆失败！", "提示", 1).then(() => {
        //     this.$router.push({ name: "Login" });
        //   })
        // });
        setInterval(() => {
          if (this.percentage < 90) {
            this.percentage += 5
          }
        }, 100);
      } else {
        this.$tool.System.alert("登陆失败！", "提示", 1).then(() => {
          this.$router.push({ name: "Login" });
        })
      }
    }
  }
</script>
<style scoped>
  .prog {
    text-align: center;
    margin-top: 20%;
  }
</style>

